import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const postfluxPlugin = createPlugin({
  id: 'postflux',
  routes: {
    root: rootRouteRef,
  },
});

export const PostfluxPage = postfluxPlugin.provide(
  createRoutableExtension({
    name: 'PostfluxPage',
    component: () =>
      import('./components/ExampleComponent').then(m => m.ExampleComponent),
    mountPoint: rootRouteRef,
  }),
);
